module.exports = __webpack_public_path__ + "media/sendyourkiki.3dc548dc.mp3";